import {Moment} from 'moment-timezone';
import {PhoneModel} from '../../../../modules/common/phone/entity/phone.model';
import {ValueAndLabelModel} from '../../../common/model/valueAndLabel.model';
import {SummaryModel} from '../../../common/entity/summary.model';
import {PermissionsModel} from '../../../common/entity/permissions.model';

export class PersonSummaryModel implements SummaryModel{
    id: number;
    permissions: PermissionsModel;
    lastName: string;
    firstName: string;
    fullName: string;
    birthDate: Moment;
    email: string;
    civility: ValueAndLabelModel;
    title: ValueAndLabelModel;
    phone: PhoneModel;
    officePhone: PhoneModel;
    mobilePhone: PhoneModel;
    gender: ValueAndLabelModel;
    dead = false;
    job: string;

    get titleLabel(): string {
        return PersonSummaryModel.resolveTileLabel(this.title?.value, this.gender?.value)
    }

    static resolveTileLabel(titleValue: string, genderValue: string) {
        console.log('resolveTileLabel', genderValue, titleValue)
        const isFemale = genderValue === 'F' || genderValue == 'MRS' || genderValue === 'MISS';
        if (titleValue) {
            switch (titleValue) {
                case 'PERSON_TITLE_COLLEAGUE':
                case 'PERSON_TITLE_DEAR_COLLEAGUE':
                    return isFemale ? 'Consoeur' : 'Confrère';
                case 'PERSON_TITLE_MISTER_MADAM':
                    return isFemale ? 'Madame' : 'Monsieur';
                case 'PERSON_TITLE_DOCTOR':
                    return 'Docteur';
                case 'PERSON_TITLE_PROFESSOR':
                    return 'Professeur';
                case 'PERSON_TITLE_MISS':
                    return 'Mademoiselle';
            }
        }
        return undefined;
    }
}
